<template>
  <nav class="groove-builder-tabs" :aria-label="config.title + ' versions'">
    <router-link :to="config.path" :class="{selected: !legacy}">{{ config.title }}</router-link>
    <router-link :to="config.legacy" :class="{selected: legacy}">{{ config.legacyTitle }}</router-link>
  </nav>
</template>
<script>
import { builderFeatures } from './contracts';
export default { name: 'BuilderNav', props: { feature: { type: String, required: true }, legacy: Boolean }, computed: { config() { return builderFeatures[this.feature]; } } };
</script>
<style>
.groove-builder-tabs { display:flex; flex-wrap:wrap; gap:6px; padding:12px 16px; border-bottom:1px solid #e3e7ee; background:#fff; }
.groove-builder-tabs a { display:inline-flex; align-items:center; min-height:44px; padding:10px 14px; border-radius:8px; color:#535c6c; font-size:14px; font-weight:600; text-decoration:none; }
.groove-builder-tabs a.selected { background:#f0eafa; color:#6939b9; }
.groove-builder-tabs a:focus-visible { outline:2px solid #6939b9; outline-offset:2px; }
@media (max-width:430px) { .groove-builder-tabs {padding:8px;gap:4px} .groove-builder-tabs a {padding:8px 10px;font-size:12px;} }
</style>
